function e(e){return typeof e==`number`&&!Number.isNaN(e)}export{e as isNumber};
//# sourceMappingURL=isNumber-ccMQhOVD.js.map